import { SvgIcon, SvgIconProps } from '@mui/material';

const ALetterIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.66667 8.69417L8 4.25L6.33333 8.69417M9.66667 8.69417L10.5 10.9167M9.66667 8.69417H6.33333M6.33333 8.69417L5.5 10.9167M0.5 5.83333C0.5 3.96667 0.5 3.03333 0.863333 2.32C1.18291 1.69282 1.69282 1.18291 2.32 0.863333C3.03333 0.5 3.96667 0.5 5.83333 0.5H10.1667C12.0333 0.5 12.9667 0.5 13.68 0.863333C14.3072 1.18291 14.8171 1.69282 15.1367 2.32C15.5 3.03333 15.5 3.96667 15.5 5.83333V10.1667C15.5 12.0333 15.5 12.9667 15.1367 13.68C14.8171 14.3072 14.3072 14.8171 13.68 15.1367C12.9667 15.5 12.0333 15.5 10.1667 15.5H5.83333C3.96667 15.5 3.03333 15.5 2.32 15.1367C1.69282 14.8171 1.18291 14.3072 0.863333 13.68C0.5 12.9667 0.5 12.0333 0.5 10.1667V5.83333Z"
          stroke="var(--mui-palette-text-secondary)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default ALetterIcon;
